import React, { Component } from "react";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { livemonitorSelector } from "store/selector";
import { messageAction } from "store/action";
import { connect } from "react-redux";
import { confirm } from "modules/theme";
import ActionButtons from "./ActionButtons";
import Tip from "./Tip";
import { Button } from "modules/theme";
import DynamicAgTableCustomFilterCallState from "./DynamicAgTableCustomFilterCallState";
import { Modal } from "react-bootstrap";
import { globalStateSelector } from "../../../../../store/selector";
import { callAction } from "../../../../../store/action";
export class DynamicCustomerTable extends Component {
  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
    this.renderActions = this.renderActions.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.columnList = [
      { field: "medium", headerName: "Medium", minWidth: 50, maxWidth: 100 },
      { field: "customer", headerName: "Customer" },
      {
        field: "state",
        headerName: "Status",
        filter: DynamicAgTableCustomFilterCallState,
        cellRenderer: this.renderStatus,
      },
      { field: "team", headerName: "Team" },
      { field: "campaign", headerName: "Campaign" },
      { field: "name", headerName: "Agent" },
      {
        field: "humanTime",
        headerName: "Time Spent",
        // cellClass: this.cellClass,
        cellRenderer: this.cellClass,
        sort: "asc",
      },
      {
        field: "actions",
        headerName: "Actions",
        cellRenderer: this.renderActions,
        minWidth: 50,
        maxWidth: 200,
      },
    ];
    this.oldList = {};
    this.state = {
      fullScreen: this.props.fullScreen,
      showModal: this.props.showModal,
      scData: this.props.scData,
    };
    console.log("state", this.state);
  }

  // handleModalOpen = (data) => {
  //   console.log("Coldata", data);
  //   console.log("this.state.showModal", this.state);
  //   const { showModalTable, showModalData } = this.props;
  //   // this.setState({ showModal: showModal });
  //   showModalData(data);
  //   showModalTable(true);

  //   // updateData();
  // };

  handleBargingClick = (params) => {
    const isSessionIdMatched = this.props.list.some(
      (item) => item.callInfo.sessionId === params.data.callInfo.sessionId
    );

    if (isSessionIdMatched) {
      params.data.callInfo.status = "start";
      // this.handleModalOpen(params.data); // Directly open modal with data
      this.props.showModalTable(true);
      this.props.showModalData(params.data);
      this.props.monitorTranscript(params.data);
    } else {
      console.log("No matching sessionId found in the list");
    }
  };

  handleInboundBlockClick = (params) => {
    const isSessionIdMatched = this.props.list.some(
      (item) => item.callInfo.sessionId === params.data.callInfo.sessionId
    );

    if (isSessionIdMatched) {
      // this.handleModalOpen(params.data); // Directly open modal with data
      this.props.showCallInboundBlockModalTable(true);
      this.props.monitorCallInboundBlock(params.data);
    } else {
      console.log("No matching sessionId found in the list");
    }
  };

  handleModalOpen = (data) => {
    console.log("Data passed to modal:", data);

    const { showModalTable, showModalData } = this.props;

    // Set state and open modal without delay
    this.setState({ scData: data });
    showModalTable(true);
    showModalData(data);
  };

  handleModalClose = () => {
    // this.setState({ showModal: false });
    const { showModalTable } = this.props;
    // this.setState({ showModal: showModal });
    showModalTable(false);
    this.props.setSummaryLoading(false);
    this.props.clearSummary();
  };

  renderStatus(params) {
    if (params.value === "ACW") {
      return <span className="ACW-box chips-common-style">{params.value}</span>;
    } else if (params.value === "Ringing") {
      return (
        <span className="Ringing-box chips-common-style">{params.value}</span>
      );
    } else if (params.value === "Mute") {
      return (
        <span className="Mute-box chips-common-style">{params.value}</span>
      );
    } else if (params.value === "Connected") {
      return (
        <span className="Connected-box chips-common-style">{params.value}</span>
      );
    } else if (params.value === "Transfer") {
      return (
        <span className="Transfer-box chips-common-style">{params.value}</span>
      );
    } else if (params.value === "Failed") {
      return (
        <span className="Failed-box chips-common-style">{params.value}</span>
      );
    }
    return (
      <span className="yellow-box chips-common-style">{params.value}</span>
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log('Greeting - shouldComponentUpdate lifecycle');
    if (this.api && nextProps.list) {
      let result = this.getData(nextProps.list);
      this.api.applyTransactionAsync(result, (result) => {
        // console.log("result applyTransactionAsync ", result);
      });
    }
    return false;
  }
  getData(list) {
    let result = {
      update: [],
      add: [],
      remove: [],
    };
    let currentId = this.shortUuid();
    for (const data of list) {
      if (data.id && this.oldList && this.oldList[data.id]) {
        result.update.push(data);
      } else {
        result.add.push(data);
      }
      this.oldList[data.id] = currentId;
    }
    for (const key in this.oldList) {
      if (Object.hasOwnProperty.call(this.oldList, key)) {
        if (this.oldList[key] != currentId) {
          result.remove.push({ id: key });
          delete this.oldList[key];
        }
      }
    }
    return result;
  }
  shortUuid() {
    return (
      "0000" + ((Math.random() * Math.pow(36, 4)) | 0).toString(36)
    ).slice(-4);
  }
  componentWillReceiveProps(nextProps, prevState) {
    console.log("nextProps", nextProps);
    console.log({ checklist: this.props.list || {} });
    // console.log("nextProps", nextProps);
    // if (nextProps.agentList) {
    //   let current = JSON.stringify(nextProps.agentList);
    //   let previous = JSON.stringify(prevState.agentList);
    //   if (current !== previous) {
    //     let agentList = nextProps.agentList;
    //     let rowData = this.processAgent(agentList);
    //     let _this = this;
    //     this.setState({ agentList: agentList, rowData : rowData},()=>{
    //       _this.dataUpdate()
    //     })
    //   }
    // }
    // if ( nextProps.timeDiff != prevState.timeDiff ) {
    //   this.setState({ timeDiff: nextProps.timeDiff})
    // }
    this.setState({
      fullScreen: nextProps.fullScreen,
      showModal: nextProps.showModal,
    });
  }
  getColumnConf(columnsConf) {
    return (
      columnsConf || {
        resizable: true,
        floatingFilter: true,
        sortable: true,
      }
    );
  }
  getColumn(columns) {
    let columnDefs = [];
    if (columns && columns.length) {
      columns.map((column) => {
        column.minWidth = column.minWidth || 100;
        column.flex = column.flex || 1;
        column.filter = column.filter || true;
        column.maxWidth = column.maxWidth || 300;
        columnDefs.push(column);
      });
    }
    return columnDefs;
  }
  cellClass(params) {
    // if (params.data && params.data.diff) {
    //   if (params.data.diff > 1200) {
    //     return "bg-danger text-dark";
    //   } else if (params.data.diff > 900) {
    //     return "bg-warning text-dark";
    //   } else if (params.data.diff > 600) {
    //     return "bg-primary text-white";
    //   } else if (params.data.diff > 300) {
    //     return "bg-success text-dark";
    //   } else if (params.data.diff > 120) {
    //     return "bg-info text-dark";
    //   } else if (params.data.diff > 60) {
    //     return "bg-light text-dark";
    //   } else if (params.data.diff > 30) {
    //     return "bg-white text-dark";
    //   }
    // }
    // return "bg-white text-dark";
    if (params.data && params.data.diff) {
      if (params.data.diff > 1200) {
        return (
          <Tip text={params.value}>
            <span className="red-box chips-common-style">{params.value}</span>
          </Tip>
        );
      } else if (params.data.diff > 900) {
        return (
          <Tip text={params.value}>
            <span className="yellow-box chips-common-style">
              {params.value}
            </span>
          </Tip>
        );
      } else if (params.data.diff > 600) {
        return (
          <Tip text={params.value}>
            <span className="blue-box chips-common-style">{params.value}</span>
          </Tip>
        );
      } else if (params.data.diff > 300) {
        return (
          <Tip text={params.value}>
            <span className="green-box chips-common-style">{params.value}</span>
          </Tip>
        );
      } else if (params.data.diff > 120) {
        return (
          <Tip text={params.value}>
            <span className="info-box chips-common-style">{params.value}</span>
          </Tip>
        );
      } else if (params.data.diff > 60) {
        return (
          <Tip text={params.value}>
            <span className="transparent-box chips-common-style">
              {params.value}
            </span>
          </Tip>
        );
      } else if (params.data.diff > 30) {
        return (
          <Tip text={params.value}>
            <span className="white-box chips-common-style">{params.value}</span>
          </Tip>
        );
      }
    }
    return <span className="white-box chips-common-style">{params.value}</span>;
  }
  getRowId(params) {
    return params.data.id;
  }
  renderActions(params) {
    const { monitorCall, configProcessor, monitorTranscript, monitorCallHangup, monitorCallInboundBlock } = this.props;
    let _this = this;
    let mainType =
      params &&
        params.data &&
        params.data.state != "ACW" &&
        params.data.mainType &&
        params.data.mainType
        ? params.data.mainType
        : "";
    console.log("mainType", params);
    if (
      params.data.state !== "IVR" &&
      params.data.state !== "Queue" &&
      params.data.state !== "Logout"
    ) {
      return (
        <ActionButtons>
          <span className="d-inline-block mr-3">
            {mainType == "call" && (
              <Tip text={`${"Call Barging"}`} key={this.shortUuid()}>
                <Button
                  btnStyle="link"
                  style={{
                    verticalAlign: "middle",
                    color: "#28A6DE",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    console.log("here monitorcall running starting");
                    monitorCall(params.data);
                  }}
                  className="material-symbols-outlined"
                >
                  headset_mic
                </Button>
              </Tip>
            )}
          </span>
          <span className="d-inline-block mr-3">
            {mainType == "call" && (
              <Tip text={`${"Message Barging"}`} key={this.shortUuid()}>
                <Button
                  btnStyle="link"
                  style={{
                    verticalAlign: "middle",
                    color: "#28A6DE",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                  onClick={() => this.handleBargingClick(params)}
                  // onClick={() => {
                  //   const isSessionIdMatched = this.props.list.some(
                  //     (item) =>
                  //       item.callInfo.sessionId ===
                  //       params.data.callInfo.sessionId
                  //   );
                  //   if (isSessionIdMatched) {
                  //     params.data.callInfo.status = "start";
                  //     this.handleModalOpen(params.data);
                  //     monitorTranscript(params.data);
                  //   } else {
                  //     console.log("No matching sessionId found in the list");
                  //   }
                  // }}
                  className="material-symbols-outlined"
                >
                  record_voice_over
                </Button>
              </Tip>
            )}
          </span>
          <span className="d-inline-block mr-3">
            {mainType == "call" && (
              <Tip text={`${"Inbound Block"}`} key={this.shortUuid()}>
                <Button
                  btnStyle="link"
                  style={{
                    verticalAlign: "middle",
                    color: "#28A6DE",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                  // onClick={() => {
                  //   // console.log("here monitorcall running starting");
                  //   monitorCallInboundBlock(params.data);
                  // }}
                  onClick={() => this.handleInboundBlockClick(params)}
                  className="material-symbols-outlined"
                >
                  phone_disabled
                </Button>
              </Tip>
            )}
          </span>
          <span className="d-inline-block mr-3">
            {mainType == "call" && (
              <Tip text={`${"Hangup"}`} key={this.shortUuid()}>
                <Button
                  btnStyle="link"
                  style={{
                    verticalAlign: "middle",
                    color: "#28A6DE",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    // console.log("here monitorcall running starting");
                    monitorCallHangup(params.data);
                  }}
                  className="material-symbols-outlined"
                >
                  call_end
                </Button>
              </Tip>
            )}
          </span>
          <span className="d-inline-block" style={{ width: 20 }}>
            <Tip text={`${"Logout"}`} key={`${""}`}>
              <Button
                btnStyle="link"
                style={{
                  verticalAlign: "middle",
                  color: "#E34242",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
                disabled={this.state.fullScreen}
                onClick={() => {
                  console.log("params force logout ", params.data);
                  confirm("Do you want to logout user?", {
                    icon: "logout",
                    showConfirmation2: false,
                  }).then((e) => {
                    configProcessor("forcelogout", params.data);
                  });
                }}
                className="material-symbols-outlined"
              >
                power_rounded
              </Button>
            </Tip>
          </span>
        </ActionButtons>
      );
    } else if (params.data.state === "IVR") {
      return (
        <ActionButtons>
          <span className="d-inline-block mr-3">
            {/* {mainType == "call" && ( */}
            <Tip text={`${"Call Barging"}`} key={this.shortUuid()}>
              <Button
                btnStyle="link"
                style={{
                  verticalAlign: "middle",
                  color: "#28A6DE",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  console.log("here monitorcall running starting");
                  monitorCall(params.data);
                }}
                className="material-symbols-outlined"
              >
                headset_mic
              </Button>
            </Tip>
            {/* )} */}
          </span>
          <span className="d-inline-block mr-3">
            {/* {mainType == "call" && ( */}
            <Tip text={`${"Message Barging"}`} key={this.shortUuid()}>
              <Button
                btnStyle="link"
                style={{
                  verticalAlign: "middle",
                  color: "#28A6DE",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
                onClick={() => this.handleBargingClick(params)}
                // onClick={() => {
                //   const isSessionIdMatched = this.props.list.some(
                //     (item) =>
                //       item.callInfo.sessionId === params.data.callInfo.sessionId
                //   );
                //   console.log(
                //     "isSessionIdMatched",
                //     this.props.list.some((item) => item.callInfo.sessionId),
                //     params.data.callInfo.sessionId
                //   );
                //   if (isSessionIdMatched) {
                //     params.data.callInfo.status = "start";
                //     this.handleModalOpen(params.data);
                //     monitorTranscript(params.data);
                //   } else {
                //     console.log("No matching sessionId found in the list");
                //   }
                //   // this.handleModalOpen();
                //   // // console.log("here monitorTranscript running starting");
                //   // monitorTranscript(params.data);
                // }}
                className="material-symbols-outlined"
              >
                record_voice_over
              </Button>
            </Tip>
            {/* )} */}
          </span>
          <span className="d-inline-block mr-3">
            {/* {mainType == "call" && ( */}
            <Tip text={`${"Inbound Block"}`} key={this.shortUuid()}>
              <Button
                btnStyle="link"
                style={{
                  verticalAlign: "middle",
                  color: "#28A6DE",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
                // onClick={() => {
                //   // console.log("here monitorcall running starting");
                //   monitorCallInboundBlock(params.data);
                // }}
                onClick={() => this.handleInboundBlockClick(params)}
                className="material-symbols-outlined"
              >
                phone_disabled
              </Button>
            </Tip>
            {/* )} */}
          </span>
          <span className="d-inline-block mr-3">
            {/* {mainType == "call" && ( */}
            <Tip text={`${"Hangup"}`} key={this.shortUuid()}>
              <Button
                btnStyle="link"
                style={{
                  verticalAlign: "middle",
                  color: "#28A6DE",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  // console.log("here monitorcall running starting");
                  monitorCallHangup(params.data);
                }}
                className="material-symbols-outlined"
              >
                call_end
              </Button>
            </Tip>
            {/* )} */}
          </span>
        </ActionButtons>
      );
    } else return null;
  }
  renderList() {
    const { list } = this.props;
    let _this = this;
    // console.log("renderList updated", list);
    if (list) {
      list.map((info) => {
        if (info.id) {
          _this.oldList[info.id] = "INIT";
        }
      });
    }
  }
  render() {
    console.log("this.props.list", this.props.list);
    const {
      columns,
      columnsConf = "",
      agStyle = { width: "100%", height: "100%;" },
      divStyle = { height: 400, margin: "0px 0px 10px 0px" },
      agClassName = "ag-theme-alpine",
      boxClassName = "ag-theme-alpine",
      list = [],
      callTranscript,
    } = this.props;
    let _this = this;

    console.log("callTranscript", callTranscript);

    let columnDefs = this.getColumn(this.columnList);
    let defaultColDef = this.getColumnConf(columnsConf);
    console.log("Rerenceder---------------------");
    this.renderList();
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <div
          style={{ width: "100%", height: "100%" }}
          className="ag-theme-quartz"
        >
          <AgGridReact
            style={agStyle}
            className={agClassName}
            onGridReady={(params) => {
              _this.api = params.api;
            }}
            animateRows={true}
            defaultColDef={defaultColDef}
            enableRangeSelection="true"
            rowData={list}
            getRowId={this.getRowId}
            rowSelection="multiple"
            suppressRowClickSelection="true"
            columnDefs={columnDefs}
          />
        </div>
      </div>
      // <div className={boxClassName} style={divStyle}>
      //   <AgGridReact
      //     style={agStyle}
      //     className={agClassName}
      //     onGridReady={(params) => {
      //       _this.api = params.api;
      //     }}
      //     animateRows={true}
      //     defaultColDef={defaultColDef}
      //     enableRangeSelection="true"
      //     rowData={list}
      //     getRowId={this.getRowId}
      //     rowSelection="multiple"
      //     suppressRowClickSelection="true"
      //     columnDefs={columnDefs}
      //   ></AgGridReact>
      //   <Modal show={this.state.showModal} onHide={this.handleModalClose}>
      //     <Modal.Header closeButton>
      //       <Modal.Title>Modal Heading</Modal.Title>
      //     </Modal.Header>
      //     <Modal.Body>
      //       <h1>Modal Content</h1>
      //     </Modal.Body>
      //     <Modal.Footer>
      //       <Button variant="secondary" onClick={this.handleModalClose}>
      //         Close
      //       </Button>
      //       <Button variant="primary" onClick={this.handleModalClose}>
      //         Save Changes
      //       </Button>
      //     </Modal.Footer>
      //   </Modal>
      // </div>
    );
  }
}
DynamicCustomerTable.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  list: livemonitorSelector.getLiveDynamic(state, { key: "customerList" }),
  // state: livemonitorSelector.getLiveDynamic(state, { key: 'state' }),
  callTranscript: globalStateSelector.getTranscriptionSet(state),
});

const dispatchToProps = (dispatch) => ({
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  clearSummary: () => dispatch(callAction.clearSummary()),
  setSummaryLoading: (data) => dispatch(callAction.setSummaryLoading({ data })),
});
export default connect(stateToProps, dispatchToProps)(DynamicCustomerTable);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DynamicCustomerTable.js